<script setup>
import { set } from 'lodash'
import BasicAutocompleteInput from '~/components/custom-formkit/BasicAutocompleteInput.vue'
import { computed, onMounted, ref } from 'vue'
const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
})
const placeholder = computed(() => props.context.attrs.placeholder || 'Type to search your lender ...')
const styleClass = computed(() => props.context.attrs.class || '')
const lenderType = computed(() => props.context.attrs.lenderType || 'sale')
const store = useLenderStore()

const inputValue = ref(props.context.value)

const fetchSuggestions = async (queryString) => {
  const isPurchase = lenderType.value === 'purchase'
  const isSale = lenderType.value === 'sale'
  const isSale2 = lenderType.value === 'sale_2'

  if (isPurchase && !store.purchaseLenders.length) {
    await store.fetchPurchaseLenders(queryString)
  } else if (isSale && !store.saleLenders.length) {
    await store.fetchSaleLenders(queryString)
  } else if (isSale2 && !store.secondSaleLenders.length) {
    await store.fetchSecondSaleLenders(queryString)
  }

  if (isSale2) {
    return store.secondSaleLenders.map((item) => item.name)
  }
  if (isSale) {
    return store.saleLenders.map((item) => item.name)
  }
  return store.purchaseLenders.map((item) => item.lender)
}

onMounted(() => {
  // Pre-warm the lender store when the form opens with a saved lender name so
  // validators that depend on the lender record (e.g. account-format rules)
  // can resolve it without waiting for the autocomplete to be opened.
  if (props.context.value) {
    fetchSuggestions(props.context.value)
  }
})
</script>

<template>
  <BasicAutocompleteInput :context="context" :fetch-function="fetchSuggestions" :placeholder="placeholder" :class="styleClass" />
</template>
